const coreLocations = [
  {
    slug: "badlapur",
    name: "Badlapur",
    district: "Thane",
    tagline: "Our Main Branch - The Heart of Vedanti Academy",
    nearbyAreas: ["Ambernath", "Ulhasnagar", "Vangni", "Neral", "Karjat"],
    distance: "0 km",
    description: "Badlapur is the home of Vedanti Academy's flagship branch, located on the 3rd Floor of Jadhav Market, above Aradhana Hotel, just minutes from Badlapur Railway Station. Students from across the Mumbai Metropolitan Region travel here for our top-rated coaching in Banking, SSC, MBA CET, Railway, and Insurance exams. Our AC classrooms equipped with digital boards, in-house library, and dedicated faculty make this the preferred destination for competitive exam aspirants.",
    whyChoose: "As our headquarters, the Badlapur branch offers the complete Vedanti experience — 360-degree hybrid doubt support, selection-centric mentorship with 'Upto Selection Support,' and a smart learning environment. Being right next to Badlapur Station on the Central Railway line makes it easily accessible from Ambernath, Ulhasnagar, Vangni, Neral, and Karjat.",
    address: "3rd Floor, Jadhav Market, above Aradhana Hotel, Badlapur, Maharashtra 421503",
    connectivity: "2-minute walk from Badlapur Railway Station (Central Line)",
  },
  {
    slug: "ambernath",
    name: "Ambernath",
    district: "Thane",
    tagline: "Top Coaching for Ambernath Students - Just One Stop Away",
    nearbyAreas: ["Badlapur", "Ulhasnagar", "Vangni", "Neral"],
    distance: "7 km from Badlapur",
    description: "Ambernath, known for its ancient Shiva temple and growing urban landscape, has a large population of youth aspiring for government jobs and MBA admissions. Vedanti Academy serves Ambernath students from our nearby Badlapur branch — just one railway station away on the Central Line. Hundreds of students from Ambernath have already cracked Banking, SSC, and MBA exams through our guidance.",
    whyChoose: "Ambernath students enjoy a quick 5-minute train ride to our Badlapur branch. With our 'Upto Selection Support' guarantee, dedicated doubt-clearing sessions, and flexible batch timings, we ensure that distance is never a barrier to your success.",
    connectivity: "5-minute train ride to Badlapur branch (1 station on Central Line)",
  },
  {
    slug: "ulhasnagar",
    name: "Ulhasnagar",
    district: "Thane",
    tagline: "Empowering Ulhasnagar's Youth for Government Jobs",
    nearbyAreas: ["Ambernath", "Badlapur", "Vangni"],
    distance: "12 km from Badlapur",
    description: "Ulhasnagar, one of the most densely populated cities in Maharashtra, is a hub for aspiring government job seekers. With its large Sindhi community and entrepreneurial spirit, many students here aim for banking and government positions. Vedanti Academy has helped numerous Ulhasnagar students crack IBPS, SBI, SSC, and Railway exams.",
    whyChoose: "Located just 2-3 stations from our Badlapur branch, Ulhasnagar students can easily commute for classes. Our affordable fee structure, flexible batch timings, and proven track record make us the top choice for competitive exam coaching in the area.",
    connectivity: "10-minute train ride to Badlapur branch (Central Line)",
  },
  {
    slug: "karjat",
    name: "Karjat",
    district: "Raigad",
    tagline: "Quality Coaching Accessible from Karjat",
    nearbyAreas: ["Neral", "Badlapur", "Khopoli"],
    distance: "25 km from Badlapur",
    description: "Karjat, nestled in the foothills of the Sahyadri ranges, is a growing town with ambitious students who aspire for government careers. Despite being in Raigad district, Karjat has excellent connectivity to Badlapur via the Central Railway line. Vedanti Academy is the go-to coaching institute for Karjat students seeking preparation for Banking, SSC, MBA CET, and Railway exams.",
    whyChoose: "Karjat students can reach our Badlapur branch in about 30 minutes by train. Our weekend batches and online hybrid model are especially popular among Karjat students who balance studies with other commitments.",
    connectivity: "30-minute train ride to Badlapur branch (Central Line)",
  },
  {
    slug: "neral",
    name: "Neral",
    district: "Raigad",
    tagline: "Best Coaching Near Neral for Competitive Exams",
    nearbyAreas: ["Karjat", "Badlapur", "Vangni", "Khopoli"],
    distance: "18 km from Badlapur",
    description: "Neral, famous as the gateway to Matheran hill station, is a growing town with aspiring government job seekers and MBA candidates. Vedanti Academy serves Neral students with easily accessible coaching from our Badlapur branch, just a few stations away on the Central Line.",
    whyChoose: "Just 20 minutes from Badlapur by train, Neral students get access to our complete coaching ecosystem including AC classrooms, digital boards, in-house library, and personalized mentorship without traveling to big cities.",
    connectivity: "20-minute train ride to Badlapur branch (Central Line)",
  },
  {
    slug: "vangni",
    name: "Vangni",
    district: "Thane",
    tagline: "Competitive Exam Coaching for Vangni Students",
    nearbyAreas: ["Badlapur", "Neral", "Ambernath"],
    distance: "8 km from Badlapur",
    description: "Vangni, a developing area between Badlapur and Neral, has a growing student population looking for quality competitive exam coaching. Vedanti Academy is the nearest premium coaching institute for Vangni residents, accessible in just minutes from our Badlapur centre.",
    whyChoose: "Being one of the closest locations to our Badlapur branch, Vangni students enjoy quick and easy access. Our morning and evening batches are designed to accommodate students with varying schedules.",
    connectivity: "8-minute train ride to Badlapur branch (Central Line)",
  },
  {
    slug: "khopoli",
    name: "Khopoli",
    district: "Raigad",
    tagline: "Best Coaching Institute Near Khopoli",
    nearbyAreas: ["Karjat", "Neral"],
    distance: "35 km from Badlapur",
    description: "Khopoli, an industrial town on the Mumbai-Pune corridor, has a strong demand for competitive exam coaching. Students from Khopoli choose Vedanti Academy for its proven results and comprehensive coaching methodology. Our Badlapur branch is the most convenient coaching destination for Khopoli residents.",
    whyChoose: "Khopoli students can utilize our online hybrid model for daily doubt-clearing while attending weekend batches at our Badlapur branch. Our comprehensive study material and mock test series can be accessed from anywhere.",
    connectivity: "45-minute journey to Badlapur branch via Karjat (Central Line)",
  },
];

export const locations = [...coreLocations];

export const getLocationBySlug = (slug) => locations.find((l) => l.slug === slug);

export const locationFaqs = (locationName) => [
  {
    q: `Where is Vedanti Academy located near ${locationName}?`,
    a: `Vedanti Academy has a branch in Badlapur (3rd Floor, Jadhav Market, above Aradhana Hotel, near Badlapur Station). Students from ${locationName} can easily access our coaching through convenient transport links. We also offer hybrid online+offline learning for maximum flexibility.`,
  },
  {
    q: `What courses does Vedanti Academy offer for students from ${locationName}?`,
    a: `We offer comprehensive coaching for Banking exams (IBPS PO/Clerk, SBI PO/Clerk, RBI, RRB), SSC exams (CGL, CHSL, MTS), Railway exams (NTPC, Group D), MBA entrance (MBA CET, SNAP, CMAT, MAT), Insurance exams (LIC, GIC, NIACL), and other Government exams (NABARD, IB ACIO, FCI, India Post, EPFO/ESIC, BBA CET).`,
  },
  {
    q: `Is there online coaching available for ${locationName} students?`,
    a: `Yes! Vedanti Academy offers a 360-degree hybrid learning model. ${locationName} students can attend live online classes during weekdays, access recorded lectures, get doubts cleared via WhatsApp and Zoom, and attend intensive in-person sessions at our branches on weekends.`,
  },
  {
    q: `What are the fees for coaching at Vedanti Academy for ${locationName} students?`,
    a: `Our fees are very competitive and affordable. We offer various packages for different courses and durations. Contact us at +91 8308776505 or visit our branch for detailed fee structure. We also offer installment options and special discounts for early birds.`,
  },
  {
    q: `What is the success rate of Vedanti Academy students from ${locationName}?`,
    a: `Vedanti Academy has an outstanding track record with 31+ achievers placed in top government banks, railways, LIC, and MBA colleges. Our students have scored 99 percentile in MBA CET and 95 percentile in CAT. We have 500+ Google reviews with a 5-star rating.`,
  },
  {
    q: `Does Vedanti Academy provide study material for ${locationName} students?`,
    a: `Yes, we provide comprehensive study material including textbooks, practice papers, previous year papers, daily quizzes, and access to our mock test series. ${locationName} students can also request free study material samples through our website.`,
  },
  {
    q: `What batch timings are available for ${locationName} students?`,
    a: `We offer flexible batch timings — Morning (8 AM - 10 AM), Afternoon (12 PM - 2 PM), Evening (5 PM - 7 PM), and Weekend batches (Saturday & Sunday). ${locationName} students can choose the batch that best fits their schedule and commute.`,
  },
  {
    q: `Can I get a free demo class from ${locationName}?`,
    a: `Absolutely! We offer free demo classes for all our courses. ${locationName} students can book a demo class through our website, call us at +91 8308776505, or WhatsApp us to schedule a convenient time.`,
  },
];
